import React, { Component } from 'react';
import { Col, Row } from 'antd';
import QueueAnim from 'rc-queue-anim';
import { Link } from 'react-router-dom'
import CaseImage from '../common/caseImage'
class Index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            grid: props.grid || 1,
            cases: props.cases || [],
            isLoading: true
        };
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.grid !== this.state.grid) {
            this.setState({ grid: nextProps.grid });
        }
    }

    render() {
        return (
            <Row key="index" gutter={8} style={{ paddingBottom: 16 }} >
                <Col xs={24} sm={24} md={16} lg={12} xl={12}>
                    <QueueAnim type="alpha" duration={1000} delay={1500} >
                        <Link key={this.state.cases[0].id} to={"/case/" + this.state.cases[0].id}><CaseImage key={this.state.cases[0].id} src={this.state.cases[0].thumbnail} style={{ marginTop: 7, width: "100%" }} /></Link>
                    </QueueAnim>
                </Col>
                <QueueAnim type="right" duration={500} delay={2000} >
                    {
                        this.state.cases.map((item, index) => (
                            index > 0 ?
                                <Col key={item.id} xs={12 * this.state.grid} sm={6 * this.state.grid} md={4 * this.state.grid} lg={4 * this.state.grid} xl={3 * this.state.grid}>
                                    <Link to={"/case/" + item.id}> <CaseImage atl={item.name} key={item.id} src={item.thumbnail} /></Link>
                                </Col> : ""

                        ))
                    }
                </QueueAnim>
            </Row>
        );
    }
}

export default Index;
